import { render, staticRenderFns } from "./monthly-update.vue?vue&type=template&id=55eb92e6&"
import script from "./monthly-update.vue?vue&type=script&lang=js&"
export * from "./monthly-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports